/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './progressbar.component.css.shim.ngstyle';
import * as i1 from '../../../../node_modules/bootstrap/dist/css/bootstrap.css.shim.ngstyle';
import * as i2 from '@angular/core';
import * as i3 from '@angular/common';
import * as i4 from '../../../../../src/app/components/progressbar/progressbar.component';
const styles_ProgressbarComponent:any[] = [i0.styles,i1.styles];
export const RenderType_ProgressbarComponent:i2.RendererType2 = i2.ɵcrt({encapsulation:0,
    styles:styles_ProgressbarComponent,data:{}});
function View_ProgressbarComponent_1(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,(null as any),(null as any),1,'div',[['style',
      'margin-top:0px;font-size:14px;text-align:right;']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i2.ɵted((null as any),['',
      '    ']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.progressText;
    _ck(_v,1,0,currVal_0);
  });
}
function View_ProgressbarComponent_2(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,(null as any),(null as any),1,'div',[['style',
      'margin-top:15px;font-size:14px;font-weight:bold;']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i2.ɵted((null as any),['    ',
      '']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.progressText;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_ProgressbarComponent_0(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵted((null as any),['\n'])),(_l()(),i2.ɵeld(0,(null as any),
      (null as any),10,'div',[['class','progress bg-striped']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i2.ɵted((null as any),['\n    '])),
      (_l()(),i2.ɵeld(0,(null as any),(null as any),4,'div',[['aria-valuemax','100'],
          ['aria-valuemin','0'],['class','progress-bar progress-bar-cloud'],['role',
              'progressbar']],[[1,'aria-valuenow',0],[4,'width',(null as any)]],(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i2.ɵted((null as any),
          ['\n         '])),(_l()(),i2.ɵand(16777216,(null as any),(null as any),1,
          (null as any),View_ProgressbarComponent_1)),i2.ɵdid(16384,(null as any),
          0,i3.NgIf,[i2.ViewContainerRef,i2.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i2.ɵted((null as any),['\n    '])),(_l()(),i2.ɵted((null as any),['\n    '])),
      (_l()(),i2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ProgressbarComponent_2)),
      i2.ɵdid(16384,(null as any),0,i3.NgIf,[i2.ViewContainerRef,i2.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i2.ɵted((null as any),['\n'])),(_l()(),i2.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i4.ProgressbarComponent = _v.component;
    const currVal_2:boolean = !_co.showOnRight;
    _ck(_v,6,0,currVal_2);
    const currVal_3:any = _co.showOnRight;
    _ck(_v,10,0,currVal_3);
  },(_ck,_v) => {
    var _co:i4.ProgressbarComponent = _v.component;
    const currVal_0:any = i2.ɵinlineInterpolate(1,'',_co.progressValue,'');
    const currVal_1:any = (_co.progressValue + '%');
    _ck(_v,3,0,currVal_0,currVal_1);
  });
}
export function View_ProgressbarComponent_Host_0(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,(null as any),(null as any),1,'ixprogressbar',
      ([] as any[]),(null as any),(null as any),(null as any),View_ProgressbarComponent_0,
      RenderType_ProgressbarComponent)),i2.ɵdid(114688,(null as any),0,i4.ProgressbarComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ProgressbarComponentNgFactory:i2.ComponentFactory<i4.ProgressbarComponent> = i2.ɵccf('ixprogressbar',
    i4.ProgressbarComponent,View_ProgressbarComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2NvbXBvbmVudHMvcHJvZ3Jlc3NiYXIvcHJvZ3Jlc3NiYXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL2NvbXBvbmVudHMvcHJvZ3Jlc3NiYXIvcHJvZ3Jlc3NiYXIuY29tcG9uZW50LnRzIiwibmc6Ly8vc3JjL3VpL3NyYy9hcHAvY29tcG9uZW50cy9wcm9ncmVzc2Jhci9wcm9ncmVzc2Jhci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL2NvbXBvbmVudHMvcHJvZ3Jlc3NiYXIvcHJvZ3Jlc3NiYXIuY29tcG9uZW50LnRzLlByb2dyZXNzYmFyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG48ZGl2IGNsYXNzPVwicHJvZ3Jlc3MgYmctc3RyaXBlZFwiPlxuICAgIDxkaXYgY2xhc3M9XCJwcm9ncmVzcy1iYXIgcHJvZ3Jlc3MtYmFyLWNsb3VkXCIgIHJvbGU9XCJwcm9ncmVzc2JhclwiIGF0dHIuYXJpYS12YWx1ZW5vdz1cInt7cHJvZ3Jlc3NWYWx1ZX19XCJcbiAgICAgICAgIGFyaWEtdmFsdWVtaW49XCIwXCIgYXJpYS12YWx1ZW1heD1cIjEwMFwiIFtzdHlsZS53aWR0aF09XCJwcm9ncmVzc1ZhbHVlKyclJ1wiPlxuICAgICAgICAgPGRpdiAqbmdJZj1cIiFzaG93T25SaWdodFwiIHN0eWxlPVwibWFyZ2luLXRvcDowcHg7Zm9udC1zaXplOjE0cHg7dGV4dC1hbGlnbjpyaWdodDtcIj57eyBwcm9ncmVzc1RleHQgfX0mbmJzcDsmbmJzcDsmbmJzcDsmbmJzcDs8L2Rpdj5cbiAgICA8L2Rpdj5cbiAgICA8ZGl2ICpuZ0lmPVwic2hvd09uUmlnaHRcIiBzdHlsZT1cIm1hcmdpbi10b3A6MTVweDtmb250LXNpemU6MTRweDtmb250LXdlaWdodDpib2xkO1wiPiZuYnNwOyZuYnNwOyZuYnNwOyZuYnNwO3t7IHByb2dyZXNzVGV4dCB9fTwvZGl2PlxuPC9kaXY+XG4iLCI8aXhwcm9ncmVzc2Jhcj48L2l4cHJvZ3Jlc3NiYXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDSVM7TUFBQTtNQUFBLDRDQUFrRjtNQUFBOztJQUFBO0lBQUE7Ozs7b0JBRXZGO01BQUE7TUFBQSw0Q0FBa0Y7TUFBQTs7SUFBQTtJQUFBOzs7O29CQU50Rix1Q0FDQTtNQUFBO01BQUEsNENBQWlDO01BQzdCO1VBQUE7Y0FBQTtVQUFBLDRDQUM2RTtVQUFBLGtCQUN4RTtVQUFBLG1EQUFBO1VBQUE7TUFBa0ksMkNBQ2pJO01BQ047YUFBQTtVQUFBLHdCQUFrSSx1Q0FDaEk7VUFBQTs7SUFIUTtJQUFMLFdBQUssU0FBTDtJQUVBO0lBQUwsWUFBSyxTQUFMOzs7SUFKaUU7SUFDdEI7SUFEM0MsV0FBaUUsVUFDdEIsU0FEM0M7Ozs7b0JDRko7TUFBQTtxQ0FBQSxVQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./aot_output/src/app/components/progressbar/progressbar.component.ngfactory.ts